const LocationIcon = '/assets/tepual/general/LocationIcon.svg';
const PhoneIcon = '/assets/centraltour/General/CentralTour-Website-PhoneIcon.svg';
const HeaderLogo = '/assets/centraltour/General/CentralTour-Website-Header-Logo-26.svg';
const FooterLogo = '/assets/centraltour/General/CentralTour-Website-Footer-Logo.svg';
const ContactBg = '/assets/centraltour/Home/CentralTour-Website-Home-Banner-Footer.jpg';
const PopupIcon = '/assets/tepual/gallery/gallery5.jpg';
const BookingActive =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-BuyTicketIcon-01.svg';
const BookingInActive =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-BuyTicketIcon-01.svg';
const CancelActive =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-CancelTicketIcon-01.svg';
const CancelInActive =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-CancelTicketIcon-01.svg';
const OriginIcon = '/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-OriginIcon-01.svg';
const DestinationIcon =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-DestinationIcon-01.svg';
const CalendarIcon =
	'/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-CalendarIcon-01.svg';
const SearchIcon = '/assets/centraltour/Home/CentralTour-Website-Home-SearchBar-SearchIcon-01.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/centraltour/General/Bus-Website-WhereToFindMyPNR-CentralTour.svg';

const contactMail =
	'/assets/centraltour/Contact/CentralTour-Website-Contact-EmailAddressIcon-01.svg';
const contactHeadphone =
	'/assets/centraltour/Contact/CentralTour-Website-Contact-PhoneNumberIcon-01.svg';
const aboutUsImage = '/assets/centraltour/about/CentralTour-Website-AboutUs-01.jpg';
const aboutUsOfficeImage = '/assets/centraltour/about/CentralTour-Website-AboutUs-02.jpg';

// banners
const destinationBanner =
	'/assets/centraltour/Destinations/CentralTour-Website-MainBanner-Destination.jpg';
const galleryBanner = '/assets/centraltour/Gallery/CentralTour-Website-MainBanner-Gallery.jpg';
const contactUsBanner = '/assets/centraltour/Contact/CentralTour-Website-MainBanner-Contact.jpg';
const aboutUsBanner = '/assets/centraltour/about/CentralTour-Website-MainBanner-AboutUs.jpg';
const tncBanner = '/assets/centraltour/tnc/CentralTour-Website-MainBanner-TermsAndConditions.jpg';
const officeBanner = '/assets/centraltour/Offices/CentralTour-Website-MainBanner-Offices.jpg';

const OfficePhoneIcon =
	'/assets/centraltour/Offices/CentralTour-Website-Offices-PhoneNumberIcon-01.svg';

const success = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Information-Gray.svg';

const tick = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess =
	'/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Login-Gray.svg';
const trips = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';

const centralTourIcons = [
	{ icon: PhoneIcon, name: 'phone' },
	{ icon: LocationIcon, name: 'location' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: ContactBg, name: 'ContactBg' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },

	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },

	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	{ icon: SearchIcon, name: 'Search' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: contactHeadphone, name: 'contactHeadphone' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: galleryBanner, name: 'galleryBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsImage, name: 'aboutUsImage' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	{ icon: aboutUsOfficeImage, name: 'aboutUsOfficeImage' },
];

export default centralTourIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/centralTourIcons.js